var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.115,
    height: 27.116,
    viewBox: "0 0 27.115 27.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link",
    transform: "translate(0.994 1)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2067",
    "data-name": "Group 2067",
    transform: "translate(-0.993 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2066",
    "data-name": "Group 2066",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42834",
    "data-name": "Path 42834",
    d: "M10.248,188.228l-3.2,3.2a3.389,3.389,0,0,1-4.794-4.792l6.391-6.391a3.388,3.388,0,0,1,4.792,0,1.13,1.13,0,0,0,1.6-1.6,5.648,5.648,0,0,0-7.988,0L.661,185.032A5.649,5.649,0,0,0,8.65,193.02l3.2-3.2a1.13,1.13,0,1,0-1.6-1.6Z",
    transform: "translate(0.993 -167.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42835",
    "data-name": "Path 42835",
    d: "M205.284.654a5.65,5.65,0,0,0-7.989,0l-3.833,3.833a1.13,1.13,0,1,0,1.6,1.6l3.833-3.833a3.389,3.389,0,1,1,4.794,4.792l-7.03,7.03a3.388,3.388,0,0,1-4.792,0,1.13,1.13,0,0,0-1.6,1.6,5.648,5.648,0,0,0,7.988,0l7.03-7.03A5.648,5.648,0,0,0,205.284.654Z",
    transform: "translate(-179.824 1)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.ab7de20e960bad834413f2c38a8597ef.svg";
export { ForwardRef as ReactComponent };